import {
  formatOptions,
  languageOptions,
  periodOptions,
  sortOptions,
  type SubtitleFilters,
} from "@/utils/subtitles";

interface SubtitleFilterPanelProps {
  filters: SubtitleFilters;
  sort: string;
  onFilterChange: (next: SubtitleFilters) => void;
  onSortChange: (next: string) => void;
  onReset: () => void;
}

interface GroupProps {
  title: string;
  icon: string;
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
}

function FilterGroup({ title, icon, options, value, onChange }: GroupProps) {
  return (
    <div className="border-b border-background-200 pb-5 last:border-b-0 last:pb-0">
      <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-900">
        <i className={`${icon} text-base text-primary-500`}></i>
        {title}
      </div>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              value === option.value
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function SubtitleFilterPanel({
  filters,
  sort,
  onFilterChange,
  onSortChange,
  onReset,
}: SubtitleFilterPanelProps) {
  return (
    <div className="space-y-5 rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-filter-3-line text-lg text-primary-500"></i>
          筛选条件
        </div>
        <button
          type="button"
          onClick={onReset}
          className="whitespace-nowrap text-xs font-medium text-foreground-500 transition-colors hover:text-accent-700"
        >
          重置筛选
        </button>
      </div>

      <FilterGroup
        title="字幕语言"
        icon="ri-translate-2"
        options={languageOptions}
        value={filters.language}
        onChange={(value) => onFilterChange({ ...filters, language: value })}
      />
      <FilterGroup
        title="资源格式"
        icon="ri-file-text-line"
        options={formatOptions}
        value={filters.format}
        onChange={(value) => onFilterChange({ ...filters, format: value })}
      />
      <FilterGroup
        title="更新时间"
        icon="ri-calendar-line"
        options={periodOptions}
        value={filters.period}
        onChange={(value) => onFilterChange({ ...filters, period: value })}
      />
      <FilterGroup
        title="排序方式"
        icon="ri-sort-desc"
        options={sortOptions}
        value={sort}
        onChange={onSortChange}
      />
    </div>
  );
}